"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _install = require("./install");

var _default = {
  install: _install.install
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6WyJpbnN0YWxsIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O2VBRWU7QUFDYkEsRUFBQUEsT0FBTyxFQUFQQTtBQURhLEMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBpbnN0YWxsIH0gZnJvbSAnLi9pbnN0YWxsJ1xuXG5leHBvcnQgZGVmYXVsdCB7XG4gIGluc3RhbGxcbn1cbiJdfQ==